// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format9 } from '../../constants';

import { format2 } from '../../constants';

/** St. Pierre & Miquelon */
const PM: PhoneNumberData = [508, 'PM', 6, format9, 9, format2];

export default PM;
